module.exports = __webpack_public_path__ + "static/img/application_2.d724112.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/main/application/application_2.jpg
// module id = F91Y
// module chunks = 1